/**
 * Registers the production service worker for the browser kiosk package.
 *
 * @since 0.0.0
 * @example
 * ```ts
 * registerServiceWorker()
 * ```
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
